import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Jumps to the top of the page on every route change (renders nothing). */
const ScrollToTop = () => {
	const { pathname } = useLocation();

	useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
			// A new page should start at its top, not animate there from the old scroll position.
			behavior: "instant",
		});
	}, [pathname]);

	return null;
};

export default ScrollToTop;
